import { useState } from "react";
import { toast } from "sonner";

import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function CommitteeMembersPanel({ canEdit, governance, onSaved }) {
  const [form, setForm] = useState({
    committee_id: "",
    name: "",
    designation: "",
    mobile: "",
  });

  const submit = async () => {
    if (!form.committee_id || !form.name || !form.designation) {
      toast.error("Choose a committee and provide name and designation");
      return;
    }
    try {
      await api.post(
        `/society-setup/governance/committees/${form.committee_id}/members`,
        form,
      );
      setForm({ committee_id: "", name: "", designation: "", mobile: "" });
      toast.success("Committee position saved");
      onSaved();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not save committee position");
    }
  };

  if (!governance) return null;
  return (
    <section className="mt-5 border bg-card p-5" data-testid="society-committee-members-panel">
      <h2 className="font-display font-bold">Committee positions</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Temporary governance identities can later link to the Member Master.
      </p>
      {canEdit && (
        <div className="mt-4 grid gap-3 md:grid-cols-4">
          <select
            data-testid="society-committee-member-term"
            onChange={(event) => setForm({ ...form, committee_id: event.target.value })}
            value={form.committee_id}
          >
            <option value="">Choose committee term</option>
            {governance.committees.map((committee) => (
              <option key={committee.committee_id} value={committee.committee_id}>
                {committee.name}
              </option>
            ))}
          </select>
          <Input
            data-testid="society-committee-member-name"
            onChange={(event) => setForm({ ...form, name: event.target.value })}
            placeholder="Name"
            value={form.name}
          />
          <Input
            data-testid="society-committee-member-designation"
            onChange={(event) => setForm({ ...form, designation: event.target.value })}
            placeholder="Designation"
            value={form.designation}
          />
          <Button data-testid="society-committee-member-save" onClick={submit}>
            Add position
          </Button>
        </div>
      )}
      <div className="mt-5 overflow-x-auto border">
        <table className="min-w-[620px] w-full text-sm">
          <thead className="bg-muted/60">
            <tr>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Designation</th>
              <th className="p-3 text-left">Committee</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {governance.members.length === 0 ? (
              <tr>
                <td className="p-5 text-center text-muted-foreground" colSpan="4">
                  No committee positions yet.
                </td>
              </tr>
            ) : governance.members.map((member) => (
              <tr className="border-t" key={member.committee_member_id}>
                <td className="p-3">{member.name}</td>
                <td className="p-3">{member.designation}</td>
                <td className="p-3">{member.committee_id}</td>
                <td className="p-3">{member.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Label className="sr-only">Committee positions</Label>
    </section>
  );
}